"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconsDefaultValues = exports.IconsBrands = void 0;
var IconsBrands = {
  Caviar: 'BRAND_CAVIAR',
  DoorDash: 'BRAND_DOORDASH'
};
exports.IconsBrands = IconsBrands;
var iconsDefaultValues = {
  Brand: IconsBrands.DoorDash,
  shouldAdjustSmallSizesWhitespace: false
};
exports.iconsDefaultValues = iconsDefaultValues;